import { ContentBlock } from "@/types";
import { createSecurityServiceContent } from "@/content/services/service-content-helpers";

export const content: ContentBlock[] = [
  ...createSecurityServiceContent({
    serviceName: "automatic security gates",
    summary:
      "Automatic security gates add a practical first layer of access control for homes, commercial yards and perimeter entries. Ozy Wide Group considers daily access, visitor handling, safety devices and control methods so the gate is secure without becoming inconvenient.",
    suitedTo: [
      "driveways",
      "commercial yards",
      "strata entries",
      "warehouse perimeters",
      "restricted parking",
      "service entrances",
    ],
    includes: [
      "gate automation advice",
      "keypad and remote access",
      "intercom or access-control coordination",
      "safety device checks",
      "fault and maintenance support",
    ],
    notes: [
      "gate type",
      "power availability",
      "vehicle flow",
      "pedestrian access",
      "safety beams",
      "manual release needs",
    ],
    process: [
      "Review the existing gate, vehicle movement and how visitors or staff should gain entry.",
      "Coordinate automation, controls and safety devices around the site layout.",
      "Test opening, closing, safety response and access methods before handover.",
    ],
    faq: [
      "Existing gates may need mechanical checks before automation is practical.",
      "Visitor access can be combined with intercoms, keypads, remotes or access-control credentials.",
      "Safety beams, force settings and manual release need to be considered for reliable daily operation.",
    ],
  }),
];
